import React from 'react';
import { MainLayout } from '../components/Layout';
import SettingsContainer from '../components/Settings/SettingsContainer';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
const Settings = ({ collapsed, setCollapsed }) => {
  return (
    <MainLayout collapsed={collapsed} setCollapsed={setCollapsed}>
      <SettingsContainer />
    </MainLayout>
  );
};

export default Settings;
